module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_brazil-55889fac.png";